<div class="top-bar flex">
    <div style="width: 100%;" class="centerWidth">
        <div class="col-12 flex">
            <div class="flex col-6">
                <img src="assets/images/topbar.svg">
                <div style="top: 3px;position: relative;"
                     *ngIf="top_bar['text']!=null && top_bar['text'].length>0">{{top_bar['text']}}</div>
                <div style="top: 3px;position: relative;" *ngIf="top_bar['text']!=null && top_bar['text'].length>0"
                     class="more cursor-pointer"
                     (click)="goToPage(top_bar_Link)"><span i18n="@@See">See</span>
                    <i class="pi {{locale=='fa' ?'pi-angle-left':'pi-angle-right'}}"></i></div>
            </div>
            <div class=" col-6">
                <div class="col-12 inline-flex" style="width: 332px;">
                    <div style="padding: 0px;width: calc(100% - 210px)"></div>
                    <div class=" menu">
                        <p-menubar [model]="items" (click)="menuClick()"></p-menubar>
                    </div>
                    <!--            <div class="mnu" (click)="goToAboutUs()" style="width: 85px" i18n="@@About us">About us</div>-->
                    <!--            <div class="mnu" style="width: 85px" >-->
                    <!--                <span (click)="menu.toggle($event)" i18n="@@Contact Us"> Contact Us</span>-->
                    <!--                <p-menu #menu [model]="items" [popup]="true"></p-menu>-->
                    <!--            </div>-->
                    <div>
                        <select [(ngModel)]="language" (change)="changLanguage()">
                            <option *ngIf="global.getCluster() != 'searchaid'" value="fa">FA</option>
<!--                            <option value="en">EN</option>-->
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
